import React from "react";
import { Upload, message } from "antd";
import { ReactComponent as UploadOutlined } from "../../assets/Icons/uploadSvg.svg";
import "./DragUpload.scss";

const { Dragger } = Upload;

const DragUpload = ({
  label,
  name = "file",
  multiple = false,
  action = "", // Pass API upload endpoint here
  customRequest, // Optional custom request handler
  onChange, // Optional handler
  readOnly = false,
  setFile,
  file
}) => {
  const uploadProps = {
    name,
    multiple,
    action,
    customRequest,
    showUploadList: false,
    onChange(info) {
      const { status } = info.file;
      onChange?.(info?.fileList);
    },
    onDrop(e) {
    
    },
  };

  return (
    <div className="dragUploadWrapper">
      {label && <label className="uploadLabel">{label}</label>}
      <Dragger {...uploadProps} className="simpleUploadInput" maxCount={1} disabled={readOnly}>
        <div className="uploadInlineContent">
          <div className="iconWrapper">
            {!readOnly && <UploadOutlined className="uploadIcon" />}
            {
              readOnly ? <span className="uploadText">{file?.name?.length > 30 ? file?.name?.slice(0, 30) + '...' : file?.name}</span> : <span className="uploadText">Drag and Drop Files</span>
            }
          </div>
          <div className="browserWrapper">
            {
              readOnly ? <span className="uploadBrowse" onClick={() => setFile?.(null)}>Remove</span> : <span className="uploadBrowse">Browse</span>
            }
          </div>
        </div>
      </Dragger>
    </div>
  );
};

export default DragUpload;
